import { formatDateUtil } from "@utils/date.util";
import { PRIMARY_KEY } from "@constants/app.constants";

const tableTitle = "Customer List";
const keyColumn = PRIMARY_KEY;
const menuUrl = "customers";
const tableColumn = [
  {
    id: "customer_name",
    numeric: false,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "mobile",
    numeric: false,
    disablePadding: false,
    label: "Mobile",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    isBadge: true,
    primaryKey: keyColumn,
    badgeText: {
      1: "Active",
      0: "Inactive",
    },
    badgeColor: {
      1: "success",
      0: "danger",
    },
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    formatData: formatDateUtil,
  },
];
const breadCrumbs = [{ name: "Customers", menu_url: "/customers" }];

const filters = [
  {
    name: "customer_name",
    id: "customer_name",
    label: "Customer Name",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
  {
    name: "email",
    id: "email",
    label: "Email",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters,
};
